import {
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import { payClaim } from "../../actions/unpaidClaims";
import * as React from "react";
import secureLocalStorage from "react-secure-storage";
import API from "../../Api/api";
import toast from "react-hot-toast";

import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { Helmet } from "react-helmet-async";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black,
    fontWeight: "bold",
    fontSize: "12px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: 2,
});
function createData(
  id,
  claim_code,
  date,
  employee_name,
  branch,
  department,
  category,
  designation,
  description,
  sanctioned_by,
  approved_by,
  amount,
  payment_status,
  status,
  approvers_email,
  approvers_position
) {
  return {
    id,
    claim_code,
    date,
    employee_name,
    branch,
    department,
    category,
    designation,
    description,
    sanctioned_by,
    approved_by,
    amount,
    payment_status,
    status,
    approvers_email,
    approvers_position,
  };
}
export default function ClaimVerification() {
  const claims = useSelector((state) => state.unpaidClaims);
  const [claimsData, setClaimsData] = React.useState(claims);
  const rows = claimsData
    .filter((d) => d.payment_status === "Not paid")
    .map((data) =>
      createData(
        data._id,
        data.claim_code,
        moment(data.date).format("DD-MM-YYYY"),
        data.employee_name,
        data.branch,
        data.department,
        data.category,
        data.designation || "staff",
        data.description,
        data.sanctioned_by,
        data.approved_by,
        data.amount,
        data.payment_status,
        data.status,
        data.approvers_email,
        data.approvers_position
      )
    );
  React.useEffect(() => {
    setClaimsData(claims);
  }, [claims]);
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const [code, setCode] = React.useState("");

  const searchData = async () => {
    let fetchingId;
    try {
      if (!code) {
        toast.error("Please enter claim code");
        return;
      }
      const claimsIn = claims.filter((d) => d.claim_code === code);
      if (claimsIn.length > 0) {
        setClaimsData(claimsIn);
        return;
      }
      fetchingId = toast.loading("Fetching claim data...");
      const res = await API.get(
        `/api/v1/eClaim?status[eq]=approved&claim_code[eq]=${code}`
      );
      if (res.data[0]?.payment_status === "Paid") {
        toast.remove(fetchingId);
        toast.error("This claim is already paid");
        return;
      }
      if (res.data.length === 0) {
        toast.remove(fetchingId);
        toast.error("No data found for this code");
        return;
      }
      if (res.data.length >= 1) {
        setClaimsData((prev) => [...prev, ...res.data]);
      }

      toast.remove(fetchingId);
      toast.success("Data successfully retrieved...");
    } catch (error) {
      toast.error(error.message);
    }
  };
  const dispatch = useDispatch();
  const payApprovedClaim = (id) => {
    if (!id) {
      toast.error("Invalid claim id");
      return;
    }
    dispatch(
      payClaim(id, {
        payed_by: user?.results?.firstName + " " + user?.results?.lastName,
        payment_status: "Paid",
        payee_branch: user?.results?.branch,
      })
    );
  };

  function showUp(code, id) {
    return toast(
      (t) => (
        <span>
          Approve payment for this claim code: <strong>{code}</strong>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}>
            <Button
              style={{ borderRadius: "5px" }}
              onClick={() => payApprovedClaim(id)}>
              Pay
            </Button>
            <Button
              style={{ borderRadius: "5px", color: "red" }}
              onClick={() => toast.dismiss(t.id)}>
              Cancel
            </Button>
          </div>
        </span>
      ),
      { duration: 10000 }
    );
  }
  return (
    <div style={{ marginTop: "100px" }}>
      <Helmet title='Pay Claim - eClaim' />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "right",
          margin: "5px",
        }}>
        <TextField
          value={code}
          required
          onChange={(e) => setCode(e.target.value)}
          size='small'
          type='text'
          label='enter claim code to search'
          placeholder='enter claim code'
          InputProps={{
            endAdornment: (
              <IconButton onClick={searchData}>
                <SearchRoundedIcon />
              </IconButton>
            ),
          }}
        />
        <Button onClick={() => setClaimsData(claims)}>Reset</Button>
      </div>
      <TableContainer
        // className='table-paper'
        component={Paper}
        elevation={0}>
        <Table
          stickyHeader
          size='small'
          sx={{
            minWidth: 650,
            "& tr > *:first-child": {
              position: "sticky",
              left: 0,

              bgcolor: "#fff",
            },
            "& tr > *:last-child": {
              position: "sticky",
              right: 0,

              bgcolor: "#fff",
            },
          }}
          aria-label='a dense table'>
          <TableHead style={{ backgroundColor: "#75CA93 " }}>
            <TableRow style={{ backgroundColor: "#75CA93 " }}>
              <StyledTableCell align='left'>
                <em>#</em>
              </StyledTableCell>
              <StyledTableCell width={"200px"} align='left'>
                CODE
              </StyledTableCell>
              <StyledTableCell align='left'>DATE</StyledTableCell>
              <StyledTableCell align='left'>EMPLOYEE NAME</StyledTableCell>
              <StyledTableCell align='left'>BRANCH</StyledTableCell>
              <StyledTableCell align='left'>DEPARTMENT</StyledTableCell>
              <StyledTableCell align='left'>CATEGORY</StyledTableCell>
              <StyledTableCell align='left'>DESIGNATION</StyledTableCell>
              <StyledTableCell align='left'>SANCTIONED BY</StyledTableCell>
              <StyledTableCell align='left'>APPROVED BY</StyledTableCell>
              <StyledTableCell align='left'>AMOUNT</StyledTableCell>
              <StyledTableCell align='left'>PAYMENT STATUS</StyledTableCell>
              <StyledTableCell align='left'>STATUS</StyledTableCell>
              <StyledTableCell align='left'>ACTION</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <StyledTableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                <StyledTableCell align='left' component='th' scope='row'>
                  <em style={{ fontWeight: "bold" }}>{index + 1}</em>
                </StyledTableCell>
                <StyledTableCell
                  style={{ minWidth: "200px" }}
                  align='left'
                  component='th'
                  scope='row'>
                  {row.claim_code}
                </StyledTableCell>
                <StyledTableCell
                  style={{ minWidth: "200px" }}
                  align='left'
                  component='th'
                  scope='row'>
                  {row.date}
                </StyledTableCell>
                <StyledTableCell style={{ minWidth: "200px" }} align='left'>
                  {row.employee_name}
                </StyledTableCell>
                <StyledTableCell
                  style={{ minWidth: "200px", textTransform: "capitalize" }}
                  align='left'>
                  {row.branch}
                </StyledTableCell>
                <StyledTableCell
                  style={{ minWidth: "200px", textTransform: "capitalize" }}
                  align='left'>
                  {row.department}
                </StyledTableCell>
                <StyledTableCell
                  style={{ minWidth: "250px", textTransform: "capitalize" }}
                  align='left'>
                  {row.category}
                </StyledTableCell>
                <StyledTableCell
                  style={{ minWidth: "250px", textTransform: "capitalize" }}
                  align='left'>
                  {row.designation}
                </StyledTableCell>
                <StyledTableCell
                  style={{ minWidth: "200px", textTransform: "capitalize" }}
                  align='left'>
                  {row.sanctioned_by}
                </StyledTableCell>
                <StyledTableCell
                  style={{ minWidth: "200px", textTransform: "capitalize" }}
                  align='left'>
                  {row.approved_by}
                </StyledTableCell>
                <StyledTableCell style={{ minWidth: "200px" }} align='left'>
                  {currencyFormatter.format(row.amount)}
                </StyledTableCell>
                <StyledTableCell
                  style={{ minWidth: "200px", textTransform: "capitalize" }}
                  align='left'>
                  {row.payment_status}
                </StyledTableCell>
                <StyledTableCell
                  style={{ minWidth: "200px", textTransform: "capitalize" }}
                  align='left'>
                  {row.status}
                </StyledTableCell>
                <StyledTableCell align='left'>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      flexGrow: 1,
                      height: "100%",
                      padding: 0,
                      margin: 0,
                    }}>
                    <Paper>
                      <Tooltip title='pay claim'>
                        <IconButton
                          onClick={() => {
                            showUp(row.claim_code, row.id);
                          }}
                          size='small'>
                          Pay
                        </IconButton>
                      </Tooltip>
                    </Paper>
                  </div>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
